// removed by extract-text-webpack-plugin
module.exports = {"sideNavCollapsed":"60px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/Container.css
// module id = 794
// module chunks = 0